import React from "react";
import AdaptationView from "../../components/AdaptationView";
import "./style.scss";
const AdaptationViewPage = () => {
  return (
    <div className="adaptation_view_page">
      <AdaptationView />
    </div>
  );
};

export default AdaptationViewPage;
